import { Component, Ref, Watch } from 'vue-property-decorator'
import Template from '@/components/BaseCurd/template'
import {
  exportRepairApply
} from '@/api/api'
import ExportButton from '@/components/ExportButton/index.vue'
import dayjs from 'dayjs'
import { cloneDeep } from 'lodash'
import AddOrEditForm from './components/AddOrEditForm.vue'
import AddOrEditRecord from '@/views/tpm/repair-record/components/AddOrEditForm.vue'
import AttachmentModal from './components/AttachmentModal'
import CodeModel from "@/components/CodeModel/index.vue"
import { DeviceTypeServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
import { RepairApplyServiceProxy, RepairRecordServiceProxy } from '@/service-proxies/app-v2/tpm.service-proxies'

const dpsp = new DeviceTypeServiceProxy()
const rasp = new RepairApplyServiceProxy()
const repairRecordServiceProxy = new RepairRecordServiceProxy();

@Component({
  AddOrEditForm,
  CodeModel,
  AddOrEditRecord
})
export default class RepairApply extends Template {
  @Ref() readonly _form_add: typeof AddOrEditForm
  @Ref() readonly _record_form_add: typeof AddOrEditRecord
  @Ref() readonly _form_edit: typeof AddOrEditForm
  // 维修申请
  name = 'RepairApply'
  options = {
    retrieve: rasp.getPageRepairApply.bind(rasp),
    search: rasp.getApplyDetail.bind(rasp),
    create: rasp.createRepairApply.bind(rasp),
    update: rasp.updateRepairApply.bind(rasp),
    delete: rasp.deleteApply.bind(rasp)
  }
  acl = {
    create: 'page_tpm_repair_add_apply',
    update: 'page_tpm_repair_edit_apply',
    delete: 'page_tpm_repair_delete_apply',
    handle: 'page_tpm_repair_implement_apply',// 执行
    export: 'page_tpm_repair_export_repair_apply' // 导出维修申请
  }
  ie = true
  waitGetData = true
  // exportFilename = this.$t('page_repair_apply') + '.xlsx'
  exportFilename = '维修申请.xlsx'
  exportFn = this.handleExport

  // deviceTypeList = []
  deviceTypes = []
  showCode=false
  dataListArr=[]
  deviceTypeId = ''
  applyStatus = 0 // 申请单状态
  attachVisible = false // 附件模态框
  attachmentInfo: any = {} // 附件信息
  addRecordVisible = false // 生成记录显隐
  apply = { applyCode: "", applyId: "" }

  get lang() {
    return {
      create: this.$t('page_tpm_repair_add_apply'),
      placeholder: this.$t('keyword'),
      search: this.$t('search'),
      edit: this.$t('edit'),
      delete: this.$t('page_business_delete_material'),
      viewAttachment: this.$t('page_tpm_check_watch_file')
    }
  }

  get urgencyMap() {
    return {
      1: this.$t('page_tpm_repair_low'),
      2: this.$t('page_tpm_repair_middle'),
      3: this.$t('page_tpm_repair_high')
    }
  }

  get applyStatusList() {
    return [
      { label: this.$t('page_tpm_repair_all'), value: 0 },
      { label: this.$t('page_tpm_repair_to_be_implemented'), value: 1 },
      { label: this.$t('page_tpm_repair_executing'), value: 2 },
      { label: this.$t('page_tpm_repair_to_be_confirmed'), value: 3 },
      { label: this.$t('page_tpm_repair_confirmed'), value: 4 }
    ]
  }

  get deviceTypeList() {
    return [{ label: this.$t('page_plan_maintenance_all_types'), value: '' }, ...this.deviceTypes]
  }

  @Watch('deviceTypeList')
  handleDeviceTypesChange(val) {
    if (val.length) {
      this.deviceTypeId = val[0].value
    }
  }


  @Watch('deviceTypeId', { immediate: true })
  handleTypeIdChange(val) {
    this.dataSource = []
    this.filters = {
      total: 0,
      size: 30,
      current: 1
    }
    this.getData()
  }

  created() {
    this.getDeviceTypeList()

    let table: any = document.getElementsByClassName('temp-table-con')
    let height = 300
    if (table) {
      height = table.clientHeight - 40
    }
    // let clientWith = document.body.clientWidth
    // console.log('clientWith', clientWith)
    this.scroll = { x: 1300, y: height }
  }

  async getDeviceTypeList() {
    let params: any = {
      keyWord: '',
      query: {
        current: 1,
        size: -1
      }
    }
    let res = await dpsp.pageDeviceType(params)
    this.selectedRows=res.records
    this.deviceTypes = res.records.map(item => ({ label: item.name, value: item.id }))
    /*if (this.deviceTypeList.length) {
      this.deviceTypeId = this.deviceTypeList[0].value
    }*/

  }

  async getData(
    current = this.filters.current,
    size = this.filters.size,
    keyWords = this.keywords,
    reload: any = false
  ) {
    if (reload) current = 1
    const fetchFn = this.options.retrieve

    let params = {
      deviceTypeId: this.deviceTypeId,
      filterPlus: false, // 是否高级筛选
      keyWords,
      param: undefined,
      applyStatus: this.applyStatus ? this.applyStatus : ''
    }

    const { records, total: t, size: s, current: c } = await fetchFn(
      current,
      params,
      size
    )
    // this.dataSource = records
    let dataLength = records.length;
      let copy = JSON.parse(JSON.stringify(records));
      let needPush = 0;
      if(dataLength < 30) {
        needPush = 30 - dataLength;
        for(var k=0; k<needPush; k++) {
          let obj = {  
            // id: 'none'
          }
          copy.push(obj)  
        }
      }  
      this.dataSource = JSON.parse(JSON.stringify(copy));



    this.filters = {
      total: Number(t),
      size: Number(s),
      current: Number(c)
    }
    // 改变申请单状态后刷新数据
    if (this.selectedRows.length) {
      this.dataSource.map(item => {
        this.selectedRows.map(ite => {
          if (item.id === ite.id) {
            ite.applyStatus = item.applyStatus
          }
        })
      })
      this.selectedRows = cloneDeep(this.selectedRows)
    }
    // 选中项不在当前页时清空checkbox选中
    let temp = cloneDeep(this.selectedRowKeys)
    temp.reverse().map((selected, index, arr) => {
      if (this.dataSource.findIndex(item => item.id === selected) < 0) {
        let del = arr.length - index - 1
        this.selectedRows.splice(del, 1) // 勾选的数据项集合
        this.selectedRowKeys.splice(del, 1)// 勾选的key值集合
      }
    })
  }

  async handleExport(type) {
    let params = {
      exportSelected: !!(this.selectedRowKeys.length),
      selectedRecords: this.selectedRowKeys,
      applyStatus: this.applyStatus ? this.applyStatus : '',
      deviceId: '',
      deviceTypeId: this.deviceTypeId,
      keyWord: this.keywords,
    }
    if (type === 'select') {
      Object.assign(params, {exportSelected: true})
    } else {
      Object.assign(params, {exportSelected: false})
    }
    return await exportRepairApply(params)
  }

  render() {
    return this.customRender()
  }

  extraHeaderAction() {
    return [
      <ExportButton
        multi={true}
        filename={this.exportFilename}
        exportFn={this.handleExport}
        disabled={!(this.dataSource.length)}
        selectedKeys={this.selectedIds}
        style="margin-left: 8px"
      />
    ]
  }

  renderHeader() {
    return (
      <div
        slot="action"
        style={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <div>
          <a-button
            v-acl={this.acl.create}
            type="primary"
            style={{ marginRight: '8px' }}
            onClick={this.openCreateWindow}
          >
            {this.lang.create}
          </a-button>
          <a-button
            v-acl={this.acl.update}
            type="default"
            style={{ marginRight: '8px' }}
            onClick={() => this.openEditWindow(this.selectedRows[0])}
            disabled={this.selectedRowKeys.length !== 1 || this.selectedRows[0].applyStatus !== 1}
          >
            {this.lang.edit}
          </a-button>
          <a-popconfirm
            title={this.$t('page_resource_pool_confirm_delete')}
            onConfirm={this.deleteData}
            okText={this.$t('yes')}
            cancelText={this.$t('no')}
            disabled={this.selectedRowKeys.length < 1}
          >
            <a-button
              v-acl={this.acl.delete}
              type="danger"
              disabled={this.selectedRowKeys.length < 1}
              style={{ marginRight: '8px' }}
            >
              {this.lang.delete}
            </a-button>
       
          </a-popconfirm>
          <a-button  onClick={()=>this.printing()} disabled={this.selectedRowKeys.length === 0}>{this.$t("page_print_code")}</a-button>
          <CodeModel visible={this.showCode}  onCancel={()=>this.cancel()} dataList={this.dataListArr}></CodeModel>

          {this.ie ? this.extraHeaderAction() : null}
        </div>
        <div>
          <app-select list={this.deviceTypeList} v-model={this.deviceTypeId} onChangeSelect={this.handleTypeChange}/>
          <app-select list={this.applyStatusList} v-model={this.applyStatus}
                      onChangeSelect={this.handleApplyStatusChange}/>
          <a-input-search
            placeholder={this.lang.placeholder}
            onSearch={this.onSearch}
            enterButton={this.lang.search}
            allowClear={true}
            style="width: auto!important;"
            v-model={this.keywords}
          ></a-input-search>
        </div>

        <a-modal
          title={this.$t('page_device_repair_record_details')}
          visible={this.addRecordVisible}
          confirm-loading={this.saveLoading}
          onOk={() => this.handleOk()}
          onCancel={() => this.handleCancel()}
          width={1000}
        >
          <AddOrEditRecord
            ref="_record_form_add"
            visible={this.addRecordVisible}
            deviceTypeId={this.deviceTypeId}
            type="add"
            apply={this.apply}
          />
        </a-modal>
      </div>
    )
  }
  printing(){
    //控制打印显隐
    this.getList()
    this.showCode=true
  }
  getList() {
    this.dataListArr = []
    this.selectedRowKeys.map(id =>{
      this.dataSource.map(item => {
        if(id === item.id) {
          this.dataListArr.push({
            code: item.applyCode,
            name: item.deviceName
          })
        }
      })
    })
  }
  cancel(){
    this.showCode=false
  }

  // 执行,确认维修申请单
  async handleApply(value) {
    let res = await rasp.implementRepairApply(value.id)
    if (res) {
      this.$message.success(this.$t('page_resource_pool_success'))
      this.getData()
    }
  }

  handleAddRecord(value) {
    this.apply.applyCode = value.applyCode;
    this.apply.applyId = value.id;
    this.addRecordVisible = true
  }

  async createRecordData() {
    let form: any = this._record_form_add;
    let data = await form.getAllData();
    if (!data) {
      return;
    }
    this.saveLoading = true;
    
    try {
      await repairRecordServiceProxy.createRepairApply(data);
      this.saveLoading = false;
      this.$message.success(this.$t("page_docdirectory_create_success"));
      this.getData()
      this.showDialog = false;
    } catch (e) {
      this.saveLoading = false;
    }
  }
  handleOk(){
    this.createRecordData();
    this.addRecordVisible = false
  }
  handleCancel(){
    this.addRecordVisible = false
  }

  // 维修申请只有在，待执行的状态才可以编辑和删除
  async deleteData() {
    const fetchFn = this.options.delete

    const { current } = this.filters
    const restDataLength = this.dataSource.length - this.selectedRowKeys.length
    try {
      await fetchFn(this.selectedRowKeys)
      this.selectedRowKeys = []
      this.$message.success(this.$t('page_user_management_delete_succeeded'))
      await this.getData(
        !restDataLength ? (current - 1 ? current - 1 : current) : current
      )
    } catch (e) {
    }

    this.showDrawer = false
  }

  handleTypeChange(value) {
    this.filters = {
      total: 0,
      size: 30,
      current: 1
    }
    this.deviceTypeId = value
  }
  handleApplyStatusChange(value) {
    this.filters = {
      total: 0,
      size: 30,
      current: 1
    }
    this.applyStatus = value
    this.dataSource = []
    this.filters = {
      total: 0,
      size: 30,
      current: 1
    }
    this.getData()
  }

  // 查看附件
  async viewAttachment(record) {
    this.changeRow(record)
    this.onSelectChange([record.id], [record])
    this.attachVisible = true
    this.attachmentInfo = await rasp.getApplyFile(record.id)
  }

  closeAttachmentModal() {
    this.attachVisible = false
  }

  get columns() {
    return [
      {
        title: this.$t('actions'),
        dataIndex: 'action',
        key: 'action',
        width: 130,
        ellipsis: true,
        customRender: (sort, _record, index) => {
          return (
            _record.id &&
            <div>
              <a
                type="link"
                onClick={(e) => {
                  e.stopPropagation()
                  this.viewAttachment(_record)
                }}
              >
                {this.$t('page_tpm_check_watch_file')}
              </a>
              <a-divider type="vertical" />
              { _record.applyStatus == 2 ? <a
                type="link"
                onClick={e => {
                  e.stopPropagation()
                  this.handleAddRecord(_record)
                }}
              >
                {this.$t('page_plan_maintenance_check_record')}
              </a> : null }
              { _record.applyStatus == 1 ? <a
                type="link"
                onClick={e => {
                  e.stopPropagation()
                  this.handleApply(_record)
                }}
              >
                {this.$t('page_plan_maintenance_edit_execution')}
              </a> : null }
            </div>
          )
        }
      },
      /*{
        title: this.$t('page_resource_pool_no'), dataIndex: 'order', width: 80, ellipsis: true,
        customRender: (val, record, arr) => (arr + 1)
      },*/
      { title: this.$t('page_plan_maintenance_application_No'), dataIndex: 'applyCode', width: 100, ellipsis: true },
      {
        title: this.$t('page_plan_maintenance_application_form_status'),
        dataIndex: 'applyStatusStr',
        width: 100,
        ellipsis: true
        // customRender: (text) => this.recordStatusMap[text]
      },
      {
        title: this.$t('page_tpm_repair_urgency'), dataIndex: 'urgencyStr', width: 100, ellipsis: true
      },
      { title: this.$t('page_tpm_check_device_code'), dataIndex: 'deviceCode', width: 100, ellipsis: true },
      { title: this.$t('page_tpm_check_device_name'), dataIndex: 'deviceName', width: 100, ellipsis: true },
      { title: this.$t('page_tpm_check_device_type'), dataIndex: 'deviceTypeName', width: 100, ellipsis: true },
      // { title: this.$t('规格型号'), dataIndex: 'code', width: 100, ellipsis: true },
      {
        title: this.$t('page_tpm_repair_occurrence_time'), dataIndex: 'malfunctionTime', width: 150, ellipsis: true,
        customRender: (text) => (text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '')
      },
      { title: this.$t('page_tpm_repair_apply_person'), dataIndex: 'applyUserName', width: 100, ellipsis: true },
      { title: this.$t('page_extranet_Fault_description'), dataIndex: 'description', width: 100, ellipsis: true }
    ]
  }

  async createData() {
    let form: any = this._form_add
    let data: any = await form.getAllData()
    // console.log(data)
    if (!data) {
      return
    }
    // const data: any = await this._form_add.manualSubmit()
    this.saveLoading = true
    const fetchFn = this.options.create
    try {
      await fetchFn(data)
      this.saveLoading = false
      this.$message.success(this.$t('page_docdirectory_create_success'))
      this.showDialog = false
      this.getData()
    } catch (e) {
      this.saveLoading = false
    }
  }
  renderDialog() {
    return (
      <a-modal
        class={this.templateModalClass}
        onCancel={() => (this.showDialog = false)}
        title={this.$t('page_tpm_repair_add_apply')}
        visible={this.showDialog}
        destroyOnClose={true}
        maskClosable={false}
        width={1000}
      >
        <div slot="footer">
          <a-button
            style="margin-right:8px"
            onClick={() => (this.showDialog = false)}
          >
            {this.$t('cancel')}
          </a-button>
          <a-button type="primary" onClick={this.createData} loading={this.saveLoading}>
            {this.createModalSaveBtn}
          </a-button>
        </div>
        <AddOrEditForm ref='_form_add' visible={this.showDialog} deviceTypeId={this.deviceTypeId} type="add"/>
      
      </a-modal>
    )
  }

  async updateData() {
    let form: any = this._form_edit
    let values: any = await form.getAllData()
    if (!values) {
      return
    }
    this.saveLoading = true
    const data = {
      ...this.editdata,
      ...values
    }
    for (let key in data) {
      if (typeof data[key] === 'undefined') {
        data[key] = ''
      }
    }
    const fetchFn = this.options.update
    try {
      await fetchFn(data)
      this.saveLoading = false
      this.$message.success(this.$t('page_docdirectory_edit_success'))
      this.showDrawer = false
      this.getData()
    } catch (e) {
      this.saveLoading = false
    }
  }

  /*编辑*/
  renderDrawer() {
    return (
      <a-modal
        className={this.templateModalClass}
        onCancel={() => (this.showDrawer = false)}
        title={this.$t('page_tpm_repair_edit_apply')}
        visible={this.showDrawer}
        destroyOnClose={true}
        maskClosable={false}
        width={1000}
      >
        <div slot="footer">
          <a-button
            style="margin-right:8px"
            onClick={() => (this.showDrawer = false)}
          >
            {this.$t('cancel')}
          </a-button>
          <a-button type="primary" onClick={this.updateData} loading={this.saveLoading}>
            {this.$t('save')}
          </a-button>
        </div>
        <AddOrEditForm ref="_form_edit" visible={this.showDrawer} deviceTypeId={this.deviceTypeId}
                       editData={this.editdata} type="edit"/>
      </a-modal>
    )
  }

  // 行点击
  rowClick(record) {
    return {
      on: {
        click: (event: any) => {
          this.selectedRowKeys = []
          this.selectedIds = []
          this.selectedRows = []
          this.selectedRowKeys.push(record.id)
          this.selectedIds.push(record.id)
          this.selectedRows.push(record)
          this.selectRowKey = record.id
        },
      },
    }
  }

  // 点击表格中的操作按钮时切换选中行
  changeRow(record) {
    this.selectRowKey = record.id
  }

  customRender() {
    return (
      <blank-view>
        {this.renderHeader()}
        <div style="height:100%">
          {this.renderBody()}
          {this.renderDialog()}
          {this.renderDrawer()}
        
          <AttachmentModal visible={this.attachVisible} data={this.attachmentInfo} onClose={this.closeAttachmentModal}/>
        </div>
      </blank-view>
    )
  }
}
